module.exports = __webpack_public_path__ + "images/et_avatar_user_120.c7418a7eea20dca2ffae88821aebce1c.png";